/* ==========================================================================
   B-FIT — Descuento automático en "Compra única" (Bee Subscriptions)
   v2 — atraviesa Shadow DOM
   Archivo: assets/onetime-price.js
   ========================================================================== */

(function () {
  'use strict';

  /* ---------- CONFIGURACIÓN ---------- */
  var SHOW_BADGE = true; // false = sin badge "-15%" dentro del widget
  var DEBUG = false; // true = escribe en consola qué está haciendo
  /* ----------------------------------- */

  var STYLE_ID = 'bfit-onetime-discount-style';
  var MAX_DEPTH = 6;

  var cachedRoot = null;
  var observedRoots = [];

  var CSS =
    '.bfit-price-old{display:block;opacity:.45;text-decoration:line-through;' +
    'text-decoration-thickness:1.5px;font-weight:400;white-space:nowrap;font-size:.9em;}' +
    '.bfit-widget-badge{display:inline-block;margin-inline-start:.4em;padding:.15em .4em;' +
    'border-radius:.25em;background:#d7282f;color:#fff;font-size:.75em;font-weight:700;' +
    'line-height:1.2;white-space:nowrap;vertical-align:middle;}';

  function log() {
    if (DEBUG) console.log.apply(console, ['[bfit]'].concat([].slice.call(arguments)));
  }

  /* ---------- recorrido de shadow roots ---------- */

  function eachShadowRoot(root, cb, depth) {
    depth = depth || 0;
    if (depth > MAX_DEPTH) return;
    var els;
    try {
      els = root.querySelectorAll('*');
    } catch (e) {
      return;
    }
    for (var i = 0; i < els.length; i++) {
      var sr = els[i].shadowRoot;
      if (sr) {
        cb(sr);
        eachShadowRoot(sr, cb, depth + 1);
      }
    }
  }

  function observeRoot(root) {
    if (observedRoots.indexOf(root) !== -1) return;
    observedRoots.push(root);
    try {
      new MutationObserver(schedule).observe(root, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    } catch (e) {
      /* ignorar */
    }
  }

  /**
   * Devuelve el root (document o ShadowRoot) que contiene el widget.
   * Cachea el resultado; si el widget desaparece, vuelve a buscar.
   */
  function findWidgetRoot() {
    if (cachedRoot) {
      try {
        if (cachedRoot.querySelector('.beez-sub-box')) return cachedRoot;
      } catch (e) {
        /* root muerto */
      }
      cachedRoot = null;
    }

    if (document.querySelector('.beez-sub-box')) {
      cachedRoot = document;
      log('widget en light DOM');
      return cachedRoot;
    }

    eachShadowRoot(document, function (sr) {
      observeRoot(sr);
      if (!cachedRoot && sr.querySelector('.beez-sub-box')) {
        cachedRoot = sr;
        log('widget en shadow root', sr.host);
      }
    });

    return cachedRoot;
  }

  function injectStyles(root) {
    var container = root === document ? document.head : root;
    if (!container) return;
    var existing = root === document ? document.getElementById(STYLE_ID) : root.querySelector('#' + STYLE_ID);
    if (existing) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent = CSS;
    container.appendChild(s);
  }

  /* ---------- porcentaje de descuento (viene del tema, light DOM) ---------- */

  function getDiscountPct() {
    var nodes = document.querySelectorAll('product-price [data-auto-discount]');
    for (var i = 0; i < nodes.length; i++) {
      if (!nodes[i].closest('product-card')) {
        var pct = parseInt(nodes[i].getAttribute('data-auto-discount'), 10);
        if (pct > 0 && pct < 100) return pct;
      }
    }
    return 0;
  }

  /* ---------- dinero ---------- */

  function parseMoney(text) {
    var clean = text.replace(/\u00A0/g, ' ');
    var match = clean.match(/[\d][\d.,\s]*/);
    if (!match) return null;

    var raw = match[0].trim();
    var digitsOnly = raw.replace(/[^\d.,]/g, '');

    var decMatch = digitsOnly.match(/[.,](\d{2})$/);
    var decSep = null;
    var intPart = digitsOnly;
    var cents = 0;

    if (decMatch) {
      decSep = digitsOnly.charAt(digitsOnly.length - 3);
      cents = parseInt(decMatch[1], 10);
      intPart = digitsOnly.slice(0, -3);
    }

    var groupSep;
    var stripped = intPart.replace(/[.,]/g, '');
    if (intPart.length !== stripped.length) {
      groupSep = intPart.replace(/[\d]/g, '').charAt(0);
    } else if (decSep) {
      groupSep = decSep === ',' ? '.' : ',';
    } else {
      groupSep = ',';
    }

    var units = parseInt(stripped, 10);
    if (isNaN(units)) return null;

    return {
      cents: units * 100 + cents,
      raw: raw,
      decSep: decSep,
      groupSep: groupSep,
      hasDecimals: !!decSep,
    };
  }

  function formatLike(original, info, newCents) {
    var units = Math.floor(newCents / 100);
    var cents = String(newCents % 100);
    while (cents.length < 2) cents = '0' + cents;
    var intStr = String(units).replace(/\B(?=(\d{3})+(?!\d))/g, info.groupSep);
    var num = info.hasDecimals ? intStr + info.decSep + cents : intStr;
    return original.replace(info.raw, num);
  }

  /* ---------- localizar la caja de compra única ---------- */

  function findOneTimeBox(root) {
    var boxes = root.querySelectorAll('.beez-sub-box');
    for (var i = 0; i < boxes.length; i++) {
      var b = boxes[i];
      var isSubscription =
        b.querySelector('.beez-select') || b.querySelector('.beez-plan-price-old');
      if (!isSubscription && b.querySelector('.beez-plan-price')) return b;
    }
    return null;
  }

  /* ---------- aplicar ---------- */

  function apply() {
    var root = findWidgetRoot();
    if (!root) return;

    injectStyles(root);

    var box = findOneTimeBox(root);
    if (!box) return;

    var priceEl = box.querySelector('.beez-plan-price');
    if (!priceEl) return;

    var wrap = priceEl.parentNode;
    var pct = getDiscountPct();

    /* sin descuento: revertir y salir */
    if (!pct) {
      var stale = wrap.querySelector('.bfit-price-old');
      if (stale) {
        var orig = stale.getAttribute('data-original');
        if (orig) priceEl.textContent = orig;
        stale.parentNode.removeChild(stale);
      }
      var staleBadge = box.querySelector('.bfit-widget-badge');
      if (staleBadge) staleBadge.parentNode.removeChild(staleBadge);
      priceEl.removeAttribute('data-bfit-done');
      return;
    }

    var existingOld = wrap.querySelector('.bfit-price-old');
    var originalText = existingOld
      ? existingOld.getAttribute('data-original')
      : priceEl.textContent;
    if (!originalText) return;

    var stamp = originalText + '|' + pct;
    if (priceEl.getAttribute('data-bfit-done') === stamp) return;

    var info = parseMoney(originalText);
    if (!info) return;

    var finalCents = info.cents - Math.round((info.cents * pct) / 100);
    if (finalCents <= 0) return;

    priceEl.textContent = formatLike(originalText, info, finalCents);

    if (!existingOld) {
      existingOld = document.createElement('div');
      existingOld.className = 'bfit-price-old beez-plan-price-old';
      wrap.appendChild(existingOld);
    }
    existingOld.setAttribute('data-original', originalText);
    existingOld.textContent = originalText;

    if (SHOW_BADGE) {
      var label = box.querySelector('.beez-plan-label');
      if (label && !label.querySelector('.bfit-widget-badge')) {
        var badge = document.createElement('span');
        badge.className = 'bfit-widget-badge';
        badge.setAttribute('aria-hidden', 'true');
        badge.textContent = '-' + pct + '%';
        label.appendChild(badge);
      }
    }

    priceEl.setAttribute('data-bfit-done', stamp);
    log('aplicado', pct + '%', originalText, '->', priceEl.textContent);
  }

  /* ---------- ciclo ---------- */

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      try {
        apply();
      } catch (e) {
        console.warn('[bfit-onetime-price]', e);
      }
    });
  }

  function start() {
    schedule();

    // El host del shadow root puede montarse después que este script.
    observeRoot(document);

    window.addEventListener('popstate', schedule);
    document.addEventListener('change', schedule, true);
    document.addEventListener('click', schedule, true);

    // Reintentos durante los primeros 10s por si la app tarda en montar
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      schedule();
      if (cachedRoot || tries > 20) clearInterval(timer);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Expuesto para diagnóstico manual desde consola
  window.bfitOnetimeDebug = function () {
    var root = findWidgetRoot();
    return {
      root: root === document ? 'document' : root && root.host,
      pct: getDiscountPct(),
      cajas: root ? root.querySelectorAll('.beez-sub-box').length : 0,
      compraUnica: root ? !!findOneTimeBox(root) : false,
    };
  };
})();
